export const CACHE_KEYS = {
    DASHBOARD: {
        DATES: 'dashboard.datesCache',
        DAY_PARTS: 'dashboard.dayPartsCache',
        ORDER_SOURCE: 'dashboard.orderSource',
        DESTINATION: 'dashboard.destinationCache',
        HOURS: 'dashboard.hoursCache',
        HEADER: 'dashboard.headerCache',
    },
};
